const UserRegister = () => import("../components/userRegisterView.vue");

/* Exporting the object routes of login module. */
export default [
    {
      name: "register",
      path: "/register",
      meta: {
        Title: "User Register",
        layout: "LoggedLayout",
        requireAuth: true
      },
      component: UserRegister,
    },
  ];